import React from 'react';
import {
    Avatar,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    IconButton,
    Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';

const VisitCreateModal = ({
    open,
    onClose,
    onCreate,
    submitting,
    createForm,
    setCreateForm,
    dictionary,
}) => {
    const theme = useTheme();
    return (
        <Dialog open={open} onClose={() => !submitting && onClose()} maxWidth="md" fullWidth>
            <DialogTitle sx={{ p: 0 }}>
                <Box sx={{ px: 2.5, py: 2, bgcolor: '#f3f4f6', borderBottom: '1px solid #e5e7eb' }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
                            <Avatar sx={{ width: 38, height: 38, bgcolor: theme.palette.primary.main }}>
                                <AddIcon sx={{ fontSize: 22, color: '#fff' }} />
                            </Avatar>
                            <Box sx={{ minWidth: 0 }}>
                                <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.1 }}>
                                    {dictionary.visitCreateTitle || 'Create visit'}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.35 }}>
                                    {dictionary.visitCreateSubtitle || 'Create a new visit'}
                                </Typography>
                            </Box>
                        </Box>
                        <IconButton onClick={onClose} size="small" sx={{ color: '#6b7280' }} disabled={submitting}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ mt: 2}}>
                <Grid container spacing={1.5} py={1}>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="datetime-local"
                            label={dictionary.visitEditStart || 'Start datetime'}
                            value={createForm.start_datetime}
                            onChange={(e) => setCreateForm((prev) => ({ ...prev, start_datetime: e.target.value }))}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="datetime-local"
                            label={dictionary.visitEditEnd || 'End datetime'}
                            value={createForm.end_datetime}
                            onChange={(e) => setCreateForm((prev) => ({ ...prev, end_datetime: e.target.value }))}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label={dictionary.visitEditPlatform || 'Platform'}
                            value={createForm.platform}
                            onChange={(e) => setCreateForm((prev) => ({ ...prev, platform: e.target.value }))}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label={dictionary.visitEditIcalUid || 'iCal UID'}
                            value={createForm.ical_uid}
                            onChange={(e) => setCreateForm((prev) => ({ ...prev, ical_uid: e.target.value }))}
                            helperText={dictionary.visitCreateIcalOptional || 'Optional'}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={dictionary.visitEditInfo || 'Info'}
                            value={createForm.info}
                            onChange={(e) => setCreateForm((prev) => ({ ...prev, info: e.target.value }))}
                            multiline
                            minRows={2}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
                <Button onClick={onClose} disabled={submitting}>
                    {dictionary.visitActionCancel || 'Cancel'}
                </Button>
                <Button variant="contained" onClick={onCreate} disabled={submitting || !createForm.start_datetime || !createForm.end_datetime || !createForm.platform}>
                    {dictionary.visitActionCreate || 'Create'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default VisitCreateModal;
